module.exports = __webpack_public_path__ + "img/big.2b8af7dc.jpg";